import '@babel/register';
import '@babel/polyfill';
import React from 'react';
import Splash from './Splash';
import Dashboard from './Dashboard';
//import { Auth0Provider, useAuth0 } from './auth0';
import config, { redirect_uri } from './config';
import './App.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import * as bulmaToast from "bulma-toast";
import './serviceWorker';
import { Auth0Provider, RedirectLoginOptions, useAuth0 } from "@auth0/auth0-react";
import { User } from '@auth0/auth0-spa-js';

interface ModeState {
  contactMessage :string
  contactEmail :string
  mode :string
  newLink :string
  showContact :boolean,
}
interface ModeProps {
  isAuthenticated :boolean
  signUp :() => void
  logout :() => void
  user :User | undefined
  getAuthTokenSilently :() => Promise<string>
}

class Modes extends React.Component<ModeProps, ModeState>  {
  constructor(props) {
    super(props);
    this.setNewLink = this.setNewLink.bind(this);
    this.toDashboard = this.toDashboard.bind(this);
    this.toSplash = this.toSplash.bind(this);
    this.showContact = this.showContact.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = { mode: this.getMode(), 
      newLink: '', 
      contactMessage: '', 
      contactEmail: '',
      showContact: false };
  }

  getMode = () => {
    const mode = window.location.href.indexOf('#dashboard') > 0 ? 'dashboard' : 'splash';
    if(mode === 'dashboard' && !this.props.isAuthenticated) {
      this.props.signUp();
    }
    return mode;
  }



  componentDidMount() {
    window.addEventListener('popstate', () => {
      this.setState({ mode: this.getMode() });
    })
  }

  setNewLink(e) {
    this.setState({ newLink: e.target.value });
  }

  toDashboard() {
    history.pushState({}, '', '/index.html#dashboard');
    this.setState({ mode: 'dashboard' });
    window.scrollTo(0, 0);
  }

  toSplash() {
    history.pushState({}, '', '/index.html');
    this.setState({ mode: 'splash' });
    window.scrollTo(0, 0);
  }

  showContact() {
    this.setState({ showContact: true })
  }

  handleSubmit(e) {
    e.preventDefault();

    fetch("https://submit-form.com/7drcnaM6uAwU-vYOqyZTL", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          message: this.state.contactMessage,
          email: this.state.contactEmail,
        })
      })
    .then(response => {
        if(response.status === 200) {
          this.setState({ showContact: false, contactMessage: '' });
          bulmaToast.toast({ message: 'Message sent!',
            type: 'is-dark',
            position: 'bottom-left',
            dismissible: true,
            duration: 4000,
            animate: { in: "bounceInUp", out: "bounceOutDown" } })
        }
    })
    .catch(function(error) {
      console.error(error);
    });
  }

  toast(message) {
    bulmaToast.toast({ message ,
      type: 'is-dark',
      position: 'bottom-left',
      dismissible: true,
      duration: 4000,
      animate: { in: "bounceInUp", out: "bounceOutDown" } })
  }

  render() {
    return <>{this.state.mode === 'splash' && <Splash newLink={this.state.newLink}
          setNewLink={this.setNewLink} 
          toDashboard={this.toDashboard} 
          signUp={this.props.signUp} 
          showContact={this.showContact}
          logout={this.props.logout} />}
          {this.state.mode === 'dashboard' && <Dashboard 
          toast={this.toast}
          newLink={this.state.newLink}
          signUp={this.props.signUp} 
          toSplash={this.toSplash} 
          user={this.props.user}
          isAuthenticated={this.props.isAuthenticated}
          logout={this.props.logout}
          getAuthTokenSilently={this.props.getAuthTokenSilently}
          showContact={this.showContact} />}

          <div className={`pk-contact modal ${this.state.showContact && 'is-active'}`}>
              <div className="modal-background" onClick={() => this.setState({ showContact: false })}></div>

              <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Thanks for reaching out!</p>
                <button className="delete" aria-label="close" onClick={() => this.setState({showContact: false})}></button>
              </header>
              <section className="modal-card-body content">
                <p>I welcome bug reports, feature requests, comments, questions, concerns, manifestos, proposals,
                  really anything that's on your mind. I&apos;ll do my best to get back to you within two business days.</p>
                <form target="_self" onSubmit={this.handleSubmit}>
                  <div className="field">
                   <label className="label">Email</label>
                   <div className="control has-icons-left has-icons-right">
                     <input className="input" name="email" type="email" placeholder="your.email@example.com" value={this.state.contactEmail}
                       onChange={(e) => this.setState({ contactEmail: e.target.value})} required />
                     <span className="icon is-small is-left">
                       <FontAwesomeIcon icon={faEnvelope} />
                     </span>
                   </div>
                  </div>

                  <div className="field">
                   <label className="label">Message</label>
                   <div className="control">
                     <textarea className="textarea" name="message" placeholder="Your message.."
                       value={this.state.contactMessage} onChange={(e) => this.setState({ contactMessage: e.target.value})} required></textarea>
                   </div>
                  </div>


                  <div className="field is-grouped">
                    <div className="control">
                      <a className="button is-text" onClick={() => this.setState({ showContact: false })}>Cancel</a>
                    </div>
                   <div className="control">
                     <button className="button is-primary" type="submit">Submit</button>
                   </div>
                  </div>

                </form>

              </section>
              </div>
            </div>
      </>
  }
}

function App(props) {
  const auth0 = useAuth0();
  let isAuthenticated =  auth0.isAuthenticated
  let signUp =  auth0.loginWithRedirect;
  let logout = () => auth0.logout({ logoutParams: {returnTo: config.returnTo }});
  let user = auth0.user;
  let getAuthTokenSilently = auth0.getAccessTokenSilently;

  if (auth0.isLoading) {
    return <div className="pk-pro-loading-screen"><h1 className="pk-brand level-item"><img src="/img/peeklink.png" /></h1></div>;
  }

  auth0.isAuthenticated && auth0.getAccessTokenSilently().then(token => {
    try {
      window.gtag('event', 'login', { event_label: 'login' });
    } catch {}

    sessionStorage.setItem('token', token);
    return fetch('/pro/ensure-user', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then(result => {
      console.log(result);
    })
  }).catch(err => console.log(err));

  return <Modes isAuthenticated={isAuthenticated}
  getAuthTokenSilently={getAuthTokenSilently}
  signUp={signUp} 
  logout={logout}
  user={user} />
}

function AuthenticatedApp(props) {
  const onRedirectCallback = () => {
    history.pushState({}, '', '/index.html#dashboard');
  }

  return <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{redirect_uri: config.redirect_uri}}>
        <App />
    </Auth0Provider>
}

export default AuthenticatedApp;
